export default __webpack_public_path__ + "static/media/educational.7bd7e59e.png";